<script>
  import PropertyInfo from './PropertyTimeline/PropertyInfo.svelte';
  import PropertyTimeLine from './PropertyTimeline/PropertyTimeline.svelte';

  import fetchNode from "../helpers/FetchNode.js";
  import standardizeDate from "../helpers/standardizeDate.js";
  import { User } from '../store.js'; 
  export let property;
  export let dateRange;
  export let grid;
  export let availability;
  export let markupPercentage;

  let user;

  const unUser = User.subscribe(v => user = v);

  const reservationBaseURL = "https://portals.airbetter.com/bookingsManagment/makereservation";

  $: blockOptions = {
      where: JSON.stringify({
          airbetterId : property.id,
          active : '1',
          day : { '>=': standardizeDate(dateRange.start) , '<=': standardizeDate(dateRange.end) }
      }),
      limit: 10000
  };
  $: blockRequest = fetchNode('propertyblock', blockOptions);

  $: reservationReqOptions = {
      where: JSON.stringify({
        airbetterId : property.id,
        status : { '!=' : 'Canceled' },
        or: [
          {
            dateFrom: {
              '>=': standardizeDate(dateRange.start),
              '<=': standardizeDate(dateRange.end),
            }
          }, 
          {
            dateTo: {
              '>=': standardizeDate(dateRange.start),
              '<=': standardizeDate(dateRange.end),
            }
          },
          {
            dateFrom: {
              '<=': standardizeDate(dateRange.start),
            },
            dateTo: {
              '>=': standardizeDate(dateRange.start)
            }
          }
        ],
      }),
      limit: 10000,
      populate : 'channelId'        
  };
  
  $: reservationsRequest = fetchNode('reservation',reservationReqOptions);
  $: bookingLink = reservationBaseURL+'?airbetterId='+property.id+'&startDate='+standardizeDate(dateRange.start)+'&endDate='+standardizeDate(dateRange.end)+'&airbetterName='+property.airbetterName;
</script>
<article class='property'>
  <PropertyInfo property={property} availability={availability} user={user} bookingLink={bookingLink}/>
  {#await reservationsRequest then reservations}
    {#await blockRequest then blocks}
      <PropertyTimeLine property={property} dateRange={dateRange} reservations={reservations} blocks={blocks} grid={grid} currency={property.currency}
        markupPercentage={markupPercentage}
      />
    {/await}
      <!-- <MultiMonthCalendar reservations={reservations} blocks={blocks} dateRange={dateRange}/> -->
  {/await}
</article>
<style>
  .property:nth-child(even) {
    background-color:#f2f2f2;  
  }
  .property {
    display: flex;
    border-bottom:1px solid #ddd;
    align-self: flex-start;
    align-items: stretch;
    overflow: hidden;
    width: fit-content;
  }
</style>